import { wishlistsStore } from 'src/stores';

export const wishlistValues = () => {
  return wishlistsStore.getAllValues();
};
